import CaptionedIcon from './CaptionedIcon'

export default CaptionedIcon
